import { customTv } from "#utils";

import type { VariantProps } from "tailwind-variants";

const headingStyles = customTv({
  base: "",
  variants: {
    level: {
      1: "text-page-headline leading-[2rem]",
      2: "text-[1.25rem] font-bold leading-[2rem] tracking-normal",
      3: "text-title-medium",
      4: "text-title-small",
    },
  },
  defaultVariants: {
    level: 1,
  },
});

type HeadingLevel = 1 | 2 | 3 | 4;

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingStyles> {
  children: React.ReactNode;
  level?: HeadingLevel;
}

export function Heading({ children, className, level = 1, ...props }: HeadingProps) {
  const Component = `h${level}` as const;

  return (
    <Component className={headingStyles({ level, class: className })} {...props}>
      {children}
    </Component>
  );
}
